// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-container {
  max-width: 800px;
  margin: 40px auto;
  padding: 40px;
  background: #fff;
  border-radius: 8px;
}

.settings-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 40px;
  color: #000;
}

.settings-section {
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 1px solid #e0e0e0;
}

.settings-section:last-of-type {
  border-bottom: none;
}

.settings-section h3 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #000;
}

.logo-upload {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.logo-preview {
  width: 150px;
  height: 60px;
  object-fit: contain;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px;
  background: #fafafa;
}

.placeholder-text {
  font-size: 14px;
  color: #666;
  padding: 12px;
  background: var(--background-color);
  border-radius: 4px;
  width: fit-content;
}

.btn-import {
  padding: 10px 24px;
  background: var(--button-color);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  width: fit-content;
  transition: background 0.3s;
}

.btn-import:hover:not(:disabled) {
  background: var(--hover-color);
}

.btn-import:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.file-info {
  font-size: 12px;
  color: #666;
  font-style: italic;
}

.color-picker-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.color-item {
  display: flex;
  align-items: center;
  gap: 16px;
}

.color-item label {
  font-size: 14px;
  color: #000;
  min-width: 150px;
}

.color-item input[type="color"] {
  width: 60px;
  height: 40px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
}

.settings-actions {
  display: flex;
  gap: 16px;
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid #e0e0e0;
}

.btn-save {
  padding: 12px 32px;
  background: var(--button-color);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s;
}

.btn-save:hover:not(:disabled) {
  background: var(--hover-color);
}

.btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-cancel {
  padding: 12px 32px;
  background: transparent;
  color: #000;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-cancel:hover {
  background: var(--background-color);
}`, "",{"version":3,"sources":["webpack://./src/pages/AccountSettingsPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".settings-container {\n  max-width: 800px;\n  margin: 40px auto;\n  padding: 40px;\n  background: #fff;\n  border-radius: 8px;\n}\n\n.settings-title {\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 40px;\n  color: #000;\n}\n\n.settings-section {\n  margin-bottom: 40px;\n  padding-bottom: 30px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.settings-section:last-of-type {\n  border-bottom: none;\n}\n\n.settings-section h3 {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  color: #000;\n}\n\n.logo-upload {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.logo-preview {\n  width: 150px;\n  height: 60px;\n  object-fit: contain;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  padding: 8px;\n  background: #fafafa;\n}\n\n.placeholder-text {\n  font-size: 14px;\n  color: #666;\n  padding: 12px;\n  background: var(--background-color);\n  border-radius: 4px;\n  width: fit-content;\n}\n\n.btn-import {\n  padding: 10px 24px;\n  background: var(--button-color);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  width: fit-content;\n  transition: background 0.3s;\n}\n\n.btn-import:hover:not(:disabled) {\n  background: var(--hover-color);\n}\n\n.btn-import:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.file-info {\n  font-size: 12px;\n  color: #666;\n  font-style: italic;\n}\n\n.color-picker-group {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.color-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.color-item label {\n  font-size: 14px;\n  color: #000;\n  min-width: 150px;\n}\n\n.color-item input[type=\"color\"] {\n  width: 60px;\n  height: 40px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.settings-actions {\n  display: flex;\n  gap: 16px;\n  margin-top: 40px;\n  padding-top: 30px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.btn-save {\n  padding: 12px 32px;\n  background: var(--button-color);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.btn-save:hover:not(:disabled) {\n  background: var(--hover-color);\n}\n\n.btn-save:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-cancel {\n  padding: 12px 32px;\n  background: transparent;\n  color: #000;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.btn-cancel:hover {\n  background: var(--background-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
